import { GameProvider } from './contexts/GameContext'
import { StatsProvider } from './contexts/StatsContext'
import { SettingsProvider } from './contexts/SettingsContext'
import Game from './components/Game'
import './App.css'

function App() {
  return (
    <SettingsProvider>
      <StatsProvider>
        <GameProvider>
          <div className="app">
            <Game />
          </div>
        </GameProvider>
      </StatsProvider>
    </SettingsProvider>
  )
}

export default App